import Home  from "./Home.vue";
import Messages from "./Messages.vue";
import AppCommodity from './components/AppCommodity.vue'

export const routes = [
    { path: '/', component: Home },
    { path: '/messages', component: Messages },
    { path: '/commodity', component: AppCommodity }
]